import React from "react";
import SolutionCont from "./SolutionCont";
import SolutionContEims from "./SolutionContEims";


const SolData = ({ activeContent }) => {
    
const contentData = {
    modelin: {
        logoSrc: "/assets/images/logo_modelin.png",
        title: "EIMS 통합 인터페이스 관리 솔루션 ModelIN", 
        date: "ModelIN은 기업의 MCI, EAI, ESB, FEP, API 등 다양한 연계 시스템에서 사용하는 인터페이스와 전문 정보를 통합 관리하는 EIMS(Enterprise Interface Management System) 솔루션입니다.",
        headImgSrc: "/assets/images/banner01.png",
        tags: ["#EIMS", "#Interface", "#전문관리", "#GS인증"],
        aboutItem : ["인터페이스 표준화 및 개발 생산성 향상", "전사 인터페이스 정보 통합·공유", "인터페이스 전 생명주기 통합 관리", "변경이력 및 영향도 추적 관리"],
        aboutImg :  "/assets/images/img_modelin.png",
        effectItem : ["개발·유지보수 생산성 향상", "표준화된 인터페이스 운영체계 확보", "정보 공유를 통한 협업 및 운영 효율 향상"],
        caseItem : [
            {
                images: '/assets/images/logo_koreabank.png', 
                name : '한국투자 저축은행 EIMS',
                desc : 'Mydata 및 외부 I/F 구축',
            },
            {
                images: '/assets/images/logo_kbbank.png', 
                name : 'KB저축은행 EIMS',
                desc : '차세대 시스템 구축',
            },
            {
                images: '/assets/images/logo_shinhan.png', 
                name : '신한은행 EIMS',
                desc : 'EIMS 구축',
            },
            {
                images: '/assets/images/logo_koreacap.png', 
                name : '한국투자 캐피탈 EIMS',
                desc : '리테일 대내외연계 구축  ',  
            },
            {
                images: '/assets/images/logo_danal.png', 
                name : '다날 EIMS',
                desc : '차세대 시스템 구축',
            },
            {
                images: '/assets/images/logo_kbinsure.png', 
                name : 'KB 손해보험 EIMS',
                desc : '차세대 시스템 구축',
            },
        ],
    },
    linkin: {
        logoSrc: "/assets/images/logo_linkin.png",
        title: "통합 업무 연계 시스템",
        date: "다양한 프로토콜, 메시지 타입, 인터페이스 등 연계 정보를 업무 시스템에 맞춰 개발 가능하게 API를 지원합니다.",
        headImgSrc: "/assets/images/banner02.png",
        tags: ["#Gateway", "#QoS", "#GS인증"],
        aboutItem : ["인터페이스 개발 표준화", "다양한 유형 인터페이스 지원", "인증인가", "고가용성 안정성 클라우드 지원"],
        aboutImg :  "/assets/images/img_linkin.png",
        effectItem : ["다양한 복합 거래를 위해 API 프로그램 지원", "접근 제어 · 인가 · 인증 등으로 보안성과 접근 제어 강화", "데이터 캐싱, 유량제어, QoS 등 API 서비스 품질에 대한 안정성 확보"],
        caseItem : [
            {
                images: '/assets/images/logo_wooricard.png', 
                name : '우리카드',
                desc : '오픈뱅킹 시스템 구축',
            },
            {
                images: '/assets/images/logo_zero.png', 
                name : '제로페이',
                desc : '국민지원금 신청 시스템 구축',
            },
            {
                images: '/assets/images/logo_zero.png', 
                name : '제로페이',
                desc : '제로페이 정책자금 플랫폼 구축',
            },
            {
                images: '/assets/images/logo_zero.png', 
                name : '제로페이',
                desc : '제로페이 정책자금 플랫폼 기능 개선',
            },
            {
                images: '/assets/images/logo_woori.png', 
                name : '우리금융',
                desc : '통합 플랫폼 구축',
            },
            {
                images: '/assets/images/logo_coocon.png', 
                name : '쿠콘',
                desc : '밀리패스 고도화 구축 사업',
            },
            {
                images: '/assets/images/logo_coocon.png', 
                name : '쿠콘',
                desc : '밀리패스 연계 시스템 구축',
            },
            {
                images: '/assets/images/logo_zero.png', 
                name : '제로페이',
                desc : '제로페이 정책자금 플랫폼 기능 개선 2차',
            },
        ],
    },
    openin: {
        logoSrc: "/assets/images/logo_openin.png",
        title: "오픈 API 포탈 · 관리 시스템",
        date: "다양한 API 개발 표준화를 하여 Doc, Test Bed등을 제공하고 관리합니다.",
        headImgSrc: "/assets/images/banner03.png",
        tags: ["#OPEN API", "#DOC", "#TEST BED"],
        aboutItem : ["Portal 고객관리", "API 정보 및 문서 이력 관리 등 라이프 사이클 관리", "문서 및 API 테스트 제공", "Scope를 통한 API 권한 관리"],
        aboutImg :  "/assets/images/img_openin.png",
        effectItem : ["공개한 다양한 API를 표준화하여 제공 가능", "공개되는 API 버전 관리를 통한 라이프 사이클 관리", "별도의 클라이언트 프로그램 없이 API 테스트 가능 "],
        caseItem : [
            {
                images: '/assets/images/logo_mg.png', 
                name : '새마을금고',
                desc : '데이터활용 서비스 및 플랫폼 고도화',
            },
        ],
    },
    collectin: {
        logoSrc: "/assets/images/logo_collectin.png",
        title: "빅데이터 수집 · 적재 시스템",
        date: "대용량에 데이터를 수집하며 필요한 형태로 가공/ 적재합니다.",
        headImgSrc: "/assets/images/banner04.png",
        tags: ["#OPEN API", "#DOC", "#TEST BED"],
        aboutItem : ["Hadoop 3.x 기반 Data Lake 구축과 데이터 거버넌스, 데이터 저장소, 데이터 가상화를 위한 통합 빅데이터 플랫폼", "데이터 수집, 데이터 저장/처리, 데이터 분석, 시각화, 운영관리를 위한 통합 환경 제공", "데이터 암호화, 데이터 비 식별(익명/가명) 처리", "데이터 암호화, 데이터 비 식별(익명/가명) 처리"],
        aboutImg :  "/assets/images/img_collectin.png",
        effectItem : ["데이터를 바탕으로 한 정확한 분석과 예측으로, 보다 빠르고 효과적인 비즈니스 전략 수립이 가능해져 기업의 경쟁력 확보", "실시간으로 변화하는 시장과 환경에 적응할 수 있도록 대용량 데이터를 수집하고 분석하여, 지속가능한 경영을 지원", "빅데이터 플랫폼을 활용하여 데이터 분석 역량을 강화하고, 이를 통해 새로운 비즈니스 기회를 창출하여 시장에서의 경쟁 우위를 확보"],
        caseItem : [
            // {
            //     images: '/assets/images/logo_thefin.png', 
            //     name : '에이피더핀',
            //     desc : '마이데이터 시스템 구축 및 개발',
            // },
            // {
            //     images: '/assets/images/logo_tfm.png', 
            //     name : 'TFM',
            //     desc : 'ESG공급망 Data 관리 시스템 구축',
            // },
            // {
            //     images: '/assets/images/logo_tfm.png', 
            //     name : 'TFM',
            //     desc : 'ESG공급망 Data 관리 시스템 구축',
            // },
        ],
    },
  };

  
  const activeData = contentData[activeContent];

  // activeData가 없으면 아무것도 렌더링하지 않음
  if (!activeData) return null;

  return (
  <>
    {activeContent === "modelin" ? (
      <SolutionContEims
        title={activeData.title}
        description={activeData.description}
        logoSrc={activeData.logoSrc}
        headImgSrc={activeData.headImgSrc}
        date={activeData.date}
        tags={activeData.tags}
        aboutItem={activeData.aboutItem}
        aboutImg={activeData.aboutImg}
        effectItem={activeData.effectItem}
        caseItem={activeData.caseItem || []}
      />
    ) : (
      <SolutionCont
        title={activeData.title}
        description={activeData.description}
        logoSrc={activeData.logoSrc}
        headImgSrc={activeData.headImgSrc}
        date={activeData.date}
        tags={activeData.tags}
        aboutItem={activeData.aboutItem}
        aboutImg={activeData.aboutImg}
        effectItem={activeData.effectItem}
        caseItem={activeData.caseItem || []}
      />
    )}
  </>
);
};

export default SolData;
